// extracted by css-extract-rspack-plugin
export default {"td":"yPKoI7sh60sQow0z","td_no_complete":"dCbmw4XUNyUoAtA7","td_progress":"lbnIyzCdw41tXQBN","td_complete":"Z_QIeDmTbFYvdIek"};